import React from 'react';
import TopHeader from '../components/TopHeader';
import ReviewForm from '../components/ReviewForm';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const ReviewPage = () => {
  const {state} = useLocation();
  const rendezvousId = state?.idRdv; 
  const prestationIds = state?.prestation_ids;
  // console.log("rendezvousId", { rendezvousId });
    // console.log("prestation_ids",  state?.prestation_ids );

  return (
    <div className="review-page" style={{ backgroundColor: '#F6F6F6', minHeight: '100vh' }}>
       <Helmet>
                            <title>Page Reviews</title>
                            <meta name="description" content="Page avis prestation" />
                      
                        </Helmet>
      <TopHeader btn={true} /> {/* Removed bg prop since it doesn't exist */}
      <main className="container mt-4">
        <ReviewForm 
          />
      </main>
    </div>
  );
};

export default ReviewPage;